export default {
  SET_Gift(state, gifts) {
    state.gifts = gifts
  },
  SET_Gift_COUNT(state, count) {
    state.giftsCount = count
  },
  REMOVE_RECORD(state, itemId) {
    const giftIndex = state.gifts.findIndex(u => u.id === itemId)
    state.gifts.splice(giftIndex, 1)
  }
}
